import { useSyncExternalStore } from 'react';
import { getAppUpdateSnapshot, subscribeAppUpdate } from '../services/appUpdateStore';

/** 全画面共通の新しい版の検知結果を購読する。 */
const useAppUpdateStatus = () => useSyncExternalStore(
  subscribeAppUpdate,
  getAppUpdateSnapshot,
  getAppUpdateSnapshot,
);

export default useAppUpdateStatus;
